//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import Song from '@/components/song.vue'

export default {
  components: {
    Song,
  },
  computed: {
    ...mapGetters(['listDetail']),
    bgStyle() {
      return {
        backgroundImage: `url(${this.listDetail.imgUrl})`,
      }
    },
  },
  methods: {
    goBack() {
      this.$router.back()
    },
  },
}
